import { makeObservable, observable, action } from 'mobx';
import type { ProQaEventMetadataResponse } from '@mark43/cad-api';

export class ProQaMetadataStore {
    @observable
    private proQaMetadataByTempEventId: Map<string, ProQaEventMetadataResponse> = new Map();

    constructor() {
        makeObservable(this);
    }

    @action
    setProQaMetadata(data: ProQaEventMetadataResponse): void {
        this.proQaMetadataByTempEventId.set(data.tempEventId, data);
    }

    @action
    clearProQaMetadata(tempEventId: string): void {
        this.proQaMetadataByTempEventId.delete(tempEventId);
    }

    getProQaMetadata(tempEventId?: string): ProQaEventMetadataResponse | undefined {
        if (!tempEventId) {
            return undefined;
        }
        return this.proQaMetadataByTempEventId.get(tempEventId);
    }
}
